export class ProductHelper {

	static hasVariants = product => Boolean(product.variants && product.variants.length)

	static hasDefaultVariant = product => Boolean(this.hasVariants(product) && product.variants.some(v => v.default))

	static requiresVariantSelection = product => Boolean(this.hasVariants(product) && !this.hasDefaultVariant(product))

	static getDefaultVariant = product => Boolean(this.hasVariants(product)) ? product.variants.find(v => v.default) : null

	static getExtraOptionGroups = (products, productId) => {
		let extraCategoryEntries = []
		const placedExtraOptionIds = new Set()
		products._productsToExtraOptions
			.filter(productToExtraOptions => productToExtraOptions.productId === productId)
			.forEach(productToExtraOption => {
				if (placedExtraOptionIds.has(productToExtraOption.extraOptionId)) return
				const variationId = productToExtraOption.variationId
				const matchingExtraCats = products._extraCategoriesToExtraOptions
					.filter(e => e.extraOptionId === productToExtraOption.extraOptionId)

				// Addon without a matching category → fallback group
				const targets = matchingExtraCats.length > 0
					? matchingExtraCats
					: [{ extraCategoryId: null }]

				targets.forEach(extraCategoryToExtraOption => {
					if (placedExtraOptionIds.has(productToExtraOption.extraOptionId)) return
					let extraCategoryEntry = extraCategoryEntries.find(e =>
						e.extraCategory.extraCategoryId === extraCategoryToExtraOption.extraCategoryId
						&& (!e.variationId || e.variationId === variationId))
					if (!extraCategoryEntry) {
						const extraCategory = extraCategoryToExtraOption.extraCategoryId === null
							? { extraCategoryId: null, extraCategoryName: 'Extras' }
							: products._extraCategories.find(c => c.extraCategoryId === extraCategoryToExtraOption.extraCategoryId)
						extraCategoryEntry = { extraCategory, extras: [] }
						if (variationId) extraCategoryEntry.variationId = variationId
						extraCategoryEntries.push(extraCategoryEntry)
					}
					if (!extraCategoryEntry.extras.some(o => o.extraOptionId === productToExtraOption.extraOptionId)) {
						const extraOption = products._options.find(o => o.extraOptionId === productToExtraOption.extraOptionId)
						extraCategoryEntry.extras.push(extraOption)
						placedExtraOptionIds.add(productToExtraOption.extraOptionId)
					}
				})
			})
		// Make free extras single select
		extraCategoryEntries.forEach(extraCategoryEntry => {
			const extrasAreFree = !extraCategoryEntry.extras.some(extraOption => extraOption.net > 0)
			extraCategoryEntry.singleSelect = extrasAreFree
		})
		// Sort extra categories
		extraCategoryEntries = extraCategoryEntries.sort((a, b) => a.extras.length - b.extras.length).sort((a, b) => (b.singleSelect ? 1 : 0) - (a.singleSelect ? 1 : 0))
		// Sort extras
		extraCategoryEntries.forEach(extraCategoryEntry => {
			extraCategoryEntry.extras = extraCategoryEntry.extras.sort((a, b) => a.extraOptionName.toUpperCase() < b.extraOptionName.toUpperCase() ? -1 : 1).sort((a, b) => a.net - b.net)
		})
		console.debug('extraCategoryEntries ', extraCategoryEntries)
		return extraCategoryEntries
	}

	static requiresExtraOptionSelection = (products, productId) => {
		let extraCategoryEntries = []
		const placedExtraOptionIds = new Set()
		products._productsToExtraOptions
			.filter(productToExtraOptions => productToExtraOptions.productId === productId)
			.forEach(productToExtraOption => {
				if (placedExtraOptionIds.has(productToExtraOption.extraOptionId)) return
				const variationId = productToExtraOption.variationId
				const matchingExtraCats = products._extraCategoriesToExtraOptions
					.filter(e => e.extraOptionId === productToExtraOption.extraOptionId)
				const targets = matchingExtraCats.length > 0
					? matchingExtraCats
					: [{ extraCategoryId: null }]
				targets.forEach(extraCategoryToExtraOption => {
					if (placedExtraOptionIds.has(productToExtraOption.extraOptionId)) return
					let extraCategoryEntry = extraCategoryEntries.find(e =>
						e.extraCategoryId === extraCategoryToExtraOption.extraCategoryId
						&& (!e.variationId || e.variationId === variationId))
					if (!extraCategoryEntry) {
						extraCategoryEntry = { extraCategoryId: extraCategoryToExtraOption.extraCategoryId, allFree: true }
						if (variationId) extraCategoryEntry.variationId = variationId
						extraCategoryEntries.push(extraCategoryEntry)
					}
					if (extraCategoryEntry.allFree) {
						const extraOption = products._options.find(o => o.extraOptionId === productToExtraOption.extraOptionId)
						extraCategoryEntry.allFree = extraCategoryEntry.allFree && !(extraOption.net > 0)
					}
					placedExtraOptionIds.add(productToExtraOption.extraOptionId)
				})
			})
		return extraCategoryEntries.some(extraCategoryEntry => extraCategoryEntry.allFree)
	}

}